export default function PrivacyPolicyPage() {
  return (
    <div className="bg-[#0A1628] text-white min-h-screen" style={{fontFamily: 'Montserrat, sans-serif'}}>
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-[#D4AF37]/20 py-6">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/031439dfb7c5b3457d1186c629c535e0.png" 
                alt="Shield Logo"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-white">Epic Real Estate</span>
            </a>
            <a href="/" className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
              Back to Home
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <h1 className="text-[40px] md:text-[56px] font-black text-white mb-8" style={{fontFamily: 'Oswald, sans-serif'}}>
            PRIVACY POLICY
          </h1>
          
          <div className="space-y-8 text-white/80 leading-relaxed">
            <div>
              <p className="text-sm text-white/60 mb-8">Last Updated: January 2026</p>
              <p className="mb-4">
                Epic Real Estate ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                1. Information We Collect
              </h2>
              <p className="mb-3">We collect information that you provide directly to us, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Personal Information:</strong> Name, email address, phone number, and any other information you choose to provide when downloading our resources or contacting us.</li>
                <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, pages visited, and time spent on pages.</li>
                <li><strong>Cookies and Tracking:</strong> We use cookies and similar tracking technologies to track activity on our website and hold certain information.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                2. How We Use Your Information
              </h2>
              <p className="mb-3">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide, maintain, and improve our services</li>
                <li>Send you the resources you request, including our Gold Dealer Lie Detector checklist</li>
                <li>Communicate with you about products, services, and promotional offers</li>
                <li>Respond to your comments, questions, and requests</li>
                <li>Monitor and analyze trends, usage, and activities</li>
                <li>Detect, prevent, and address technical issues and fraudulent activity</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                3. Information Sharing and Disclosure
              </h2>
              <p className="mb-3">We may share your information in the following circumstances:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>With Your Consent:</strong> We may share your information with third parties when you give us permission to do so.</li>
                <li><strong>Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf, such as email delivery and hosting services.</li>
                <li><strong>Business Partners:</strong> We may share your information with vetted gold dealers and business partners who can provide you with relevant services. You will always have the option to opt out of such sharing.</li>
                <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                4. Data Security
              </h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                5. Your Rights and Choices
              </h2>
              <p className="mb-3">You have the following rights regarding your personal information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Access and Update:</strong> You may request access to or correction of your personal information.</li>
                <li><strong>Opt-Out:</strong> You may opt out of receiving promotional communications from us by following the unsubscribe instructions in those communications.</li>
                <li><strong>Cookies:</strong> Most web browsers are set to accept cookies by default. You can usually choose to set your browser to remove or reject cookies.</li>
                <li><strong>Do Not Track:</strong> We do not currently respond to "Do Not Track" signals.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                6. Third-Party Links
              </h2>
              <p>
                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to read the privacy policies of any third-party sites you visit.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                7. Children's Privacy
              </h2>
              <p>
                Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18. If you become aware that a child has provided us with personal information, please contact us.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                8. Changes to This Privacy Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                9. Contact Us
              </h2>
              <p className="mb-3">
                If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
              </p>
              <div className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-6">
                <p className="font-semibold text-white mb-2">Epic Real Estate</p>
                <p>Email: privacy@epicrealestate.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] border-t border-[#D4AF37]/20 py-8 md:py-12">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            <div className="flex items-center gap-3 md:gap-4">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/031439dfb7c5b3457d1186c629c535e0.png" 
                alt="Shield Logo"
                className="h-8 w-8 md:h-10 md:w-10 object-contain"
              />
              <p className="text-xs text-white/70">Epic Real Estate</p>
            </div>

            <div className="flex items-center gap-4 md:gap-8">
              <a href="/privacy-policy" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
                Terms &amp; Conditions
              </a>
            </div>
          </div>

          <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-white/10 text-center">
            <p className="text-[10px] md:text-xs text-white/50">
              © 2026 Epic Real Estate. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
